export const GET_WEBHOOKS = 'getWebhooks';
export const CREATE_WEBHOOK = 'createWebhook';
export const UPDATE_WEBHOOK = 'updateWebhook';
export const DELETE_WEBHOOK = 'deleteWebhook';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
